import { isSSR } from "./is-ssr";

export function hasLocalStorage() {
  return !isSSR() && "localStorage" in window;
}
